import { TOption } from '@intellecteu/common-ui';
import { MemoryEnum } from 'data';
import { ACTIVE, ALL_HEALTH_STATUSES, ALL_VALUE, INACTIVE } from './dictionary';

export const image = 'digitalasset/canton-open-source:2.7.9';
export const DEFAULT_IMAGE_REGISTRY = 'ghcr.io/digital-asset/decentralized-canton-sync/docker';
export const DEFAULT_DOMAIN_IMAGE_REPO = 'canton';
export const DEFAULT_DOMAIN_IMAGE_TAG = '0.5.10';
export const DEFAULT_PARTICIPANT_IMAGE_REPO = 'canton-participant';
export const DEFAULT_PARTICIPANT_IMAGE_TAG = '0.5.10';

/** Splice versions at or above this no longer require migration id on validator create. */
export const SPLICE_MIGRATION_OPTIONAL_MIN_VERSION = '0.6.8';

export const memoryDefault = '1';
export const memoryLimit = '2';
export const cpuLimit = '2';
export const cpuRequested = '1';
export const sizeDefault = '1';
export const backupSizeDefault = '1';
export const maxDurationInSecDefault = 1;
export const retentionInSecDefault = 1;
export const memoryLimitParticipantValidator = '9';
export const memoryRequestedParticipantValidator = '3';

/** Create Validator:
 appInfoCantonNameService
 */
export const cpuWalletCnsLimit = '1';
export const cpuWalletCnsRequested = '0.1';
export const memoryWalletCnsLimit = '1536';
export const memoryWalletCnsRequested = '240';

export const defaultJvmOptionsValidator =
  '-XX:+UseG1GC -XX:+UseStringDeduplication -XX:MaxRAMPercentage=75' +
  ' -XX:InitialRAMPercentage=75 -Dscala.concurrent.context.numThreads=8 -XX:ActiveProcessorCount=8 -Dpekko.http.server.idle-timeout=20m -Dpekko.http.client.idle-timeout=20m';

export const defaultJvmOptionsParticipant =
  '-XX:+UseG1GC -XX:+UseStringDeduplication -XX:MaxRAMPercentage=75 -XX:InitialRAMPercentage=75' +
  ' -Dscala.concurrent.context.numThreads=12 -XX:ActiveProcessorCount=12';

export const minTopupInterval = '1m';
export const targetThroughput = 33330;

export const IMAGE_REPO = 'ghcr.io/digital-asset/decentralized-canton-sync/docker';

export type UnitAdapter = {
  value: string;
  unit: MemoryEnum | keyof typeof MemoryEnum;
};

export const memory = Object.values(MemoryEnum).map((el) => ({ value: el, label: el }));

export const FROM = 0;
export const PAGE_SIZE = 5;

export const allFilterOption = { label: 'All', value: 'All', disabled: false };

export const healthOptions: TOption[] = [
  {
    label: ALL_HEALTH_STATUSES,
    value: ALL_VALUE,
    disabled: false,
  },
  {
    label: ACTIVE,
    value: true,
  },
  {
    label: INACTIVE,
    value: false,
  },
];
